import { memo } from 'react';

import FindStoreNearMe from './FindStoreNearMe';

export * from './types';

export default memo(FindStoreNearMe);
